import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination, ResponseDetails } from "../../Interfaces/Interfaces";
import CustomerService from "../../services/CustomerService";

export const getCustomers = (data: Pagination) => {
  const api = new CustomerService().getCustomers(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res) {
          dispatch({
            type: 'CUSTOMERS',
            payload: res,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            }
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const getCustomerDetails = (id: string) => {
  const api = new CustomerService().getCustomerDetails(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: 'CUSTOMERS',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            }
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

